@use "@styles/variables";

@layer base-components {
    .breakableText {
        overflow: hidden;
        line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        white-space: pre-line;
    }
}
